import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import formatName from 'I18n/utils/formatName';
import ApprovalUnifiedEventStepContent from './ApprovalUnifiedEventStepContent';
import ApprovalUnifiedEventTimestamp from './ApprovalUnifiedEventTimestamp';
import ApprovalUnifiedEventNote from './ApprovalUnifiedEventNote';
import useUnifiedEventSubmittedUser from '../../hooks/useUnifiedEventSubmittedUser';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ApprovalUnifiedEventStepApproved(props) {
  const {
    event
  } = props;
  const approver = useUnifiedEventSubmittedUser(event);
  if (!approver) {
    return null;
  }
  const approverName = formatName({
    firstName: approver.firstName,
    lastName: approver.lastName
  });
  return /*#__PURE__*/_jsx("div", {
    "data-test-id": "approval-unified-event-step-approved",
    children: /*#__PURE__*/_jsxs(ApprovalUnifiedEventStepContent, {
      children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "productApprovals.unifiedEvents.ApprovalUnifiedEventStepApproved",
        options: {
          approverName
        }
      }), /*#__PURE__*/_jsx(ApprovalUnifiedEventTimestamp, {
        event: event
      }), /*#__PURE__*/_jsx(ApprovalUnifiedEventNote, {
        event: event
      })]
    })
  });
}